import type { Category } from "@/types/comic";

export const categories: Category[] = [
  {
    id: "romance",
    name: "爱情",
    nameEn: "Romance",
    description: "甜蜜心动与虐恋纠葛，每一帧都让人心跳加速的恋爱物语。",
    icon: "ri-heart-3-line",
    color: "accent",
  },
  {
    id: "fantasy",
    name: "奇幻",
    nameEn: "Fantasy",
    description: "魔法、异世界与冒险，开启天马行空的幻想旅程。",
    icon: "ri-magic-line",
    color: "primary",
  },
  {
    id: "suspense",
    name: "悬疑",
    nameEn: "Suspense",
    description: "层层反转的烧脑谜题，真相往往藏在被忽略的细节之中。",
    icon: "ri-spy-line",
    color: "foreground",
  },
  {
    id: "school",
    name: "校园",
    nameEn: "School",
    description: "青春校园日常，青涩懵懂的少年少女成长故事。",
    icon: "ri-graduation-cap-line",
    color: "secondary",
  },
  {
    id: "action",
    name: "热血",
    nameEn: "Action",
    description: "战斗与成长，燃到沸腾的热血冒险与格斗人生。",
    icon: "ri-sword-line",
    color: "accent",
  },
  {
    id: "city",
    name: "都市",
    nameEn: "Urban",
    description: "现代都市的职场与生活，真实、励志又治愈。",
    icon: "ri-building-2-line",
    color: "primary",
  },
  {
    id: "historical",
    name: "古风",
    nameEn: "Historical",
    description: "古代宫廷与江湖恩怨，唯美精致的东方古风画卷。",
    icon: "ri-leaf-line",
    color: "secondary",
  },
  {
    id: "healing",
    name: "治愈",
    nameEn: "Healing",
    description: "温暖治愈系日常，抚慰每一个疲惫的心灵。",
    icon: "ri-cup-line",
    color: "accent",
  },
];